export default "__VITE_ASSET__Wn9jozW6__"